import api from "helpers/api";


export const recognition = async (data) => {
    try {
        const response = await api.post("/facility/recognition_new", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
};

export const saveCarImage = async (data) => {
    try {
        const response = await api.post("/facility/image_path_new", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
};

export const updateSpaceUse = async (data) => {
    try {
        const response = await api.post("/facility/edit_space_use", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
};

export const checkFee = async (data) => {
    try {
        const response = await api.post("/facility/check_fee_new", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
};

export const checkFeeOutTime = async (data) => {
    try {
        const response = await api.post("/facility/check_fee_out_time", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
};

export const modifyCarInfo = async (data) => {
    try {
        const response = await api.post("/facility/modify_carnum_new", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

export const onPaymentFee = async (data) => {
    try {
        const response = await api.post("/facility/payment_new", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

export const getDiscountList = async (data) => {
    try {
        const response = await api.post("/facility/discount_list_new", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

export const applyOrCancelDiscountOutTime = async (data) => {
    try {
        const response = await api.post("/facility/discount_mobile_out_time", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

export const applyOrCancelDiscountUnpaid = async (data) => {
    try {
        const response = await api.post("/facility/discount_mobile_unpaid", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}



export const setUnpaid = async (data) => {
    try {
        const response = await api.post("/facility/unpaid_new", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

export const uploadDiscountImage = async (data) => {
    try {
        const response = await api.post("/facility/upload_discount_image", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

export const setUnpaidCustom = async (data) => {
    try {
        const response = await api.post("/facility/unpaid_custom", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

export const checkParkingEntry = async (data) => {
    try {
        const response = await api.post("/facility/check_entry_unpaid", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

export const checkParkingEntryDiscount = async (data) => {
    try {
        const response = await api.post("/facility/check_entry_unpaid_discount", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

export const getParkingTid = async (data) => {
    try {
        const response = await api.post("/facility/get_parking_tid", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

export const getParkingOperateTime = async (data) => {
    try {
        const response = await api.post("/facility/get_parking_operate_time", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

export const carImageSub = async (data) => {
    try {
        const response = await api.post("/facility/car_image_sub", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

export const carImageSubUpload = async (data) => {
    try {
        const response = await api.post("/facility/car_image_sub_upload", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

export const carImageSubDelete = async (data) => {
    try {
        const response = await api.post("/facility/car_image_sub_delete", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

export const getMembership = async (data) => {
    try {
        const response = await api.post("/facility/get_membership", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}